import styled from "styled-components";


export const ReimbursementContainer = styled.div`
  width: 100%;
  padding: 0px;
  background-color: #f6f6f6;
  padding-top: 10px;
  height: 100vh;
`;

export const Card = styled.div`
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.05);
    padding: 16px;
    margin-bottom: 15px;
    margin-left: 10px;
    margin-right: 10px;
`;

export const CardContent = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
`;
export const CardRight = styled.div`
`;

export const Title = styled.div`
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 70%;
`;

export const Status = styled.div`
    font-size: 12px;
    margin-bottom: 2px;
    &.submitted{
        color: #f0ad4e;
    }
    &.approved{
        color: #29a19c;
    }
    &.rejected{
        color: #ff5c5c;
    }
`;

export const TextDate = styled.div`
    font-size: 12px;
    color: #888;
`;

export const Amount = styled.div`
    font-size: 16px;
    font-weight: bold;
    color: #333;
    white-space: nowrap;
    text-align: right;
`;